import { convertYearInputToPayload } from '../../functions/convert';

export const InsertWarranty = (value) => {
  return {
    invImage: value.invImage ? value.invImage.originFileObj : null,
    packageImage: value.packageImage ? value.packageImage.originFileObj : null,
    telephone: value.telephone,
    fullName: value.fullName,
    mobileBrandId: value.mobileBrandId,
    mobileModelName: value.mobileModelName,
    productId: value.productId,
    channelBuyId: value.channelBuyId,
    warrantyNumberCode: value.warrantyNumberCode,
    purchaseDate: value.purchaseDate,
  };
};
export const UpdateExpPayload = (values) => {
  return {
    warrantyId: values.warrantyId,
    expireDate: values.expireDate,
    remark: values.remark,
  };
};
export const UpdateRegEditPayload = (value) => {
  return {
    invImage: value.invImage ? value.invImage.originFileObj : null,
    packageImage: value.packageImage ? value.packageImage.originFileObj : null,
    telephone: value.telephone,
    fullName: value.fullName,
    mobileBrandId: value.mobileBrandId,
    mobileModelName: value.mobileModelName,
    productId: value.productId,
    channelBuyId: value.channelBuyId,
    warrantyId: value.warrantyId,
    warrantyNumberCode: value.warrantyNumberCode,
    purchaseDate: value.purchaseDate,
  };
};

//claim-list
export const SendLineMsg = (value) => {
  return {
    claimId: value.claimId,
    message: value.message,
  };
};
export const UpdateProcessStatus = (value) => {
  return {
    claimId: value.claimId,
    processStatus: value.processStatus,
  };
};
export const UpdateRemark = (value) => {
  return {
    claimId: value.claimId,
    remark: value.remark,
  };
};
export const UpdateTracking = (value) => {
  return {
    claimId: value.claimId,
    shippingId: value.shippingId,
    trackingNumber: value.trackingNumber,
    shippingDate: convertYearInputToPayload(value.shippingDate),
  };
};

//claim-add
export const InsertClaim = (value) => {
  return {
    claimImage: value.claimImage ? value.claimImage.originFileObj : null,
    receiptImage: value.receiptImage ? value.receiptImage.originFileObj : null,
    warrantyId: value.warrantyId,
    customerCode: value.customerCode,
    detail1: value.detail1,
    detail2: value.detail2,
    breakdownId: value.breakdownId,
    breakdownSubId: value.breakdownSubId,
    addressLine1: value.addressLine1,
    addressLine2: value.addressLine2,
    subDistrictId: value.subDistrictId,
    zipcode: value.zipcode,
    other: value.other,
    isCreateNewAddress: value.isCreateNewAddress,
  };
};

//claim-view
export const approveClaim = (value) => {
  return {
    claimIdList: value.claimIdList,
  };
};
export const cancelClaim = (value) => {
  return {
    claimId: value.claimId,
    cancelReason: value.cancelReason,
  };
};
export const noApproveClaim = (value) => {
  return {
    claimId: value.claimId,
    rejectReason: value.rejectReason,
  };
};
export const updateProduct = (value) => {
  return {
    claimId: value.claimId,
    claimCode: value.claimCode,
    mobileBrandId: value.mobileBrandId,
    mobileModelName: value.mobileModelName,
    productId: value.productId,
    remark: value.remark,
  };
};

//claim-edit
export const UpdateClaimEdit = (values) => {
  const formData = new FormData();

  formData.append('claimId', values.claimId);
  formData.append('customerCode', values.customerCode);
  formData.append('detail1', values.detail1);
  formData.append('detail2', values.detail2);
  formData.append('breakdownId', values.breakdownId);
  formData.append('breakdownSubId', values.breakdownSubId);
  formData.append('addressLine1', values.addressLine1);
  formData.append('addressLine2', values.addressLine2);
  formData.append('subDistrictId', values.subDistrictId);
  formData.append('zipCode', values.zipCode);
  formData.append('other', values.other);

  if (values?.claimImageUrl && values?.claimImageUrl.length > 0) {
    const file = values?.claimImageUrl[0];
    if (file.originFileObj) {
      formData.append('claimImage', file.originFileObj);
    } else if (file.url) {
      formData.append('claimImageUrl', file.url);
    }
  }

  if (values?.receiptImageUrl && values?.receiptImageUrl.length > 0) {
    const file = values?.receiptImageUrl[0];
    if (file.originFileObj) {
      formData.append('receiptImage', file.originFileObj);
    } else if (file.url) {
      formData.append('receiptImageUrl', file.url);
    }
  }

  return formData;
};

//scan delivery
export const UpdateExcel = (values) => {
  const formData = new FormData();

  formData.append('shippingId', values.shippingId);
  if (values?.excelFile && values.excelFile.length > 0) {
    const file = values.excelFile[0];
    file.originFileObj && formData.append('excelFile', file.originFileObj);
  }

  return formData;
};

//customer
export const SendLineUser = (value) => {
  return {
    customerId: value.customerId,
    message: value.message,
  };
};

export const UpdateTel = (value) => {
  return {
    customerId: value.customerId,
    telephone: value.telephone,
  };
};

export const UpdateUserInfo = (value) => {
  return {
    customerId: value.customerId,
    fullName: value.fullName,
    birthday: value.birthday,
    customerLevel: 'GENERAL',
    email: value.email,
  };
};

//product-warranty
export const UpdateProductList = (values) => {
  const formData = new FormData();

  formData.append('productId', values.productId);
  formData.append('productTypeId', values.productTypeId);
  formData.append('barcodeShortcut', values.barcodeShortcut);
  formData.append('productFullName', values.productFullName);
  formData.append('itemCode', values.itemCode);
  formData.append('productStatus', values.productStatus);
  formData.append('warrantyPeriod', values.warrantyPeriod);
  formData.append('remark', values.remark);
  formData.append('allowWarranty', values.allowWarranty);
  formData.append('allowClaim', values.allowClaim);
  formData.append('categoryId', values.categoryId);
  formData.append('isWarrantyNumberRequired', values.isWarrantyNumberRequired);

  if (values?.productImageUrl && values?.productImageUrl.length > 0) {
    const file = values?.productImageUrl[0];
    if (file.originFileObj) {
      formData.append('productImage', file.originFileObj);
    } else if (file.url) {
      formData.append('productImageUrl', file.url);
    }
  }
  return formData;
};

//permission
export const updatePermission = ({ userId, selectedRowKeys, dataSource }) => {
  return {
    userId: userId,
    privilegeWhyData: dataSource?.map((item) => {
      return {
        code: item.code,
        status: selectedRowKeys.includes(item.id) ? 'ACTIVE' : 'INACTIVE',
      };
    }),
  };
};

export const InsertQr = (values) => {
  return {
    categoryId: values.categoryId,
    recipientEmail: values.recipientEmail,
    urlLink: values.urlLink,
    serialNumberAmount: parseInt(values.serialNumberAmount, 10) || 0,
    remark: values.remark,
    startDate: values.startDate,
    expireDate: values.expireDate,
  };
};

export const InsertColor = (value) => {
  return {
    categoryCode: value.categoryCode,
    categoryName: value.categoryName,
    detail1: value.detail1,
    detail2: value.detail2,
    remark: value.remark,
    defaultWarrantyPeriod: parseInt(value.defaultWarrantyPeriod, 10) || 0,
    defaultClaimQty: parseInt(value.defaultClaimQty, 10) || 0,
  };
};

export const DeleteColor = (value) => {
  return {
    categoryId: value.categoryId,
    remark: value.remark,
  };
};

export const UpdateCategory = (value) => {
  return {
    categoryId: value.categoryId,
    categoryCode: value.categoryCode,
    categoryName: value.categoryName,
    detail1: value.detail1,
    detail2: value.detail2,
    remark: value.remark,
    defaultWarrantyPeriod: parseInt(value.defaultWarrantyPeriod, 10) || 0,
    defaultClaimQty: parseInt(value.defaultClaimQty, 10) || 0,
  };
};
